import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LanguageAPIService } from '../../services/api/language-api.service';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-language-popup',
  templateUrl: './language-popup.component.html',
  styleUrls: ['./language-popup.component.scss'],
  standalone: false,
})
export class LanguagePopupComponent implements OnInit {
  public constructor(
    public _activeModal: NgbActiveModal,
    private _languageAPIService: LanguageAPIService,
    private _globalService: GlobalService
  ) {}

  @Input() title: string = 'defaultModal.title';
  @Input() successButton: string = 'common.confirmButton';
  @Input() cancelButton: string = 'common.cancelButton';
  @Input() selectedLanguage: string;

  languages: app.models.Language[];

  public ngOnInit(): void {
    this.selectedLanguage = this._globalService.language;
    this._languageAPIService.getTenantLanguages().subscribe(result => {
      this.languages = result;
    });
  }

  public buttonClicked(status: any) {
    if (status) {
      localStorage.setItem('selectedLanguage', this.selectedLanguage);
    }
    this._activeModal.close(status);
  }

  public setLanguage(lang: string) {
    this.selectedLanguage = lang;
  }
}
